import ModalComp from "themes/elements/Modal";
import ModalFooter from "../modalFooter";

function ApproveCounsilor({
  setIsApprove,
  isApprove,
  isChangeLoading,
  handleApproveCounsilor = () => {},
  data,
}) {
  const handleReject = () => {
    handleApproveCounsilor(data);
  };

  return (
    <ModalComp
      title="Approve this change?"
      footer={
        <ModalFooter
          handlePrimaryBtn={() => setIsApprove(false)}
          primaryBtnVariant="secondary"
          primaryBtnText="Cancel"
          secondaryBtnLoading={isChangeLoading}
          handleSecondaryBtn={handleReject}
          secondaryBtnvariant="primary"
          secondaryBtnText="Submit"
        />
      }
      open={isApprove}
      setOpen={(Value) => setIsApprove(Value)}
    >
      {`This councillor will take over as the active in-office councillor, and will be reflected everywhere. `}
    </ModalComp>
  );
}

export default ApproveCounsilor;
